<template>
    <v-dialog
        v-model="show"
        hide-overlay
        max-width="700px"
        transition="dialog-bottom-transition"
        content-class="provider-dialog">
        <v-card class="rounded-lg">
            <v-toolbar flat color="primary" dark>
                <v-icon left>mdi-account-arrow-right</v-icon>
                <v-toolbar-title>{{ isEdit ? 'Modifica' : 'Nuovo' }} Fornitore</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container class="pa-6">
                <v-progress-linear v-if="!formLoaded" indeterminate color="primary"></v-progress-linear>
                <form v-if="formLoaded" ref="form">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.name"
                                :error-messages="nameErrors"
                                label="Nome"
                                required
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                @input="$v.form.name.$touch()"
                                @blur="$v.form.name.$touch()">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <if65-tag-selector
                                :multiple="false"
                                v-model="form.organization_name"
                                :items="organizations"
                                label="Azienda"
                                :outlined="true"
                                :dense="true"
                                prependInnerIcon="mdi-office-building"/>
                        </v-col>
                    </v-row>
                    <v-card class="mb-4 pa-3 rounded-lg" outlined>
                        <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2">mdi-contacts</v-icon>
                            <span class="text-subtitle-1 font-weight-medium primary--text">Contatti</span>
                        </div>

                        <div v-for="(contatto, index) in form.emails" :key="index" class="mb-2">
                            <v-row>
                                <v-col cols="5">
                                    <v-text-field
                                        v-model="contatto.email"
                                        label="Email"
                                        prepend-inner-icon="mdi-email"
                                        outlined
                                        dense
                                        required>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field
                                        v-model="contatto.phone"
                                        label="Telefono"
                                        prepend-inner-icon="mdi-phone"
                                        outlined
                                        dense>
                                    </v-text-field>
                                </v-col>
                                <v-col v-if="index===0" cols="2" class="pt-0 pl-0">
                                    <v-btn color="success" text icon @click="addEmails()" style="margin-top: 12px;">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col v-else cols="2" class="pt-0 pl-0">
                                    <v-btn color="error" text icon @click="removeEmails(index)" style="margin-top: 12px;">
                                        <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                    <v-row>
                        <v-col>
                            <v-textarea
                                v-model="form.send_file_description"
                                :error-messages="sendFileDescriptionErrors"
                                label="Descrizione invio file"
                                required
                                outlined
                                dense
                                rows="3"
                                prepend-inner-icon="mdi-file-document-outline"
                                @input="$v.form.send_file_description.$touch()"
                                @blur="$v.form.send_file_description.$touch()">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions class="pt-4">
                        <v-spacer></v-spacer>
                        <v-btn text @click="show = false" class="mr-2">Annulla</v-btn>
                        <v-btn color="primary" type="submit" @click.prevent="saveProvider">
                            <v-icon left>mdi-content-save</v-icon>
                            Salva
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import If65TagSelector from "../../components/widgets/If65TagSelector.vue";

export default {
    components: {If65TagSelector},
    mixins: [validationMixin],
    validations: {
        form: {
            name: {required},
            send_file_description: {required},
            // organization_name: {required},
        }
    },
    props: {
        providerId: {
            default: null
        },
        clone: {
            default: false
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: false,
            organizations: [],
            form: {
                name: '',
                send_file_description: '',
                organization_name: '',
                emails:[
                    {'email': '', 'phone': ''},
                ]
            },
            formLoaded: false,
            deletedEmail: [],
            addEmail: 0
        }
    },
    computed: {
        isEdit() {
            return this.providerId !== null;
        },
        nameErrors() {
            const errors = [];
            if (this.$v.form.name.$dirty && !this.$v.form.name.required) {
                errors.push('Campo richiesto');
            }
            return errors;
        },
        sendFileDescriptionErrors() {
            const errors = [];
            if (this.$v.form.send_file_description.$dirty) {
                if (!this.$v.form.send_file_description.required) {
                    errors.push('Campo richiesto');
                }
            }
            return errors;
        },
    },
    mounted() {
        this.initForm()
    },
    watch: {
        value: {
            handler() {
                this.show = this.value
            },
            immediate: true
        },
        show() {
            this.$emit('input', this.show)
        }
    },
    methods: {
        formIsValid() {
            this.$v.$touch()
            return !this.$v.$invalid
        },
        initForm() {
            this.formLoaded = false
            Promise.all(
                [
                    this.loadProvider(),
                    this.loadOrganizations()
                ]
            ).then(() => {
                this.formLoaded = true
            })
        },
        loadOrganizations() {
            return this.$organizationService.list().then(
                resp => {
                    this.organizations = resp.data.reduce((array, item) => {
                        array.push(item.name)
                        return array
                    }, [])
                }
            )
        },
        loadProvider() {
            if (this.providerId) {
                return this.$providerService.get(this.providerId).then(
                    response => {
                        this.form.name = response.data.name;
                        this.form.send_file_description = response.data.send_file_description;
                        this.form.organization_name = response.data.organization_name;
                        this.form.emails = response.data.emails
                    }
                )
            }
            return Promise.resolve();
        },
        saveProvider() {
            if (this.formIsValid()) {
                const saveApi = (
                    this.isEdit ? this.$providerService.patch(this.providerId, {...this.form, deleted_email: this.deletedEmail }) : this.$providerService.post(this.form)
                );
                saveApi.then(
                    () => {
                        this.$emit('providerSaved')
                        this.$dtoast.pop({
                            preset: "success",
                            content: 'Insegna salvata',
                        })
                    }
                ).catch(xhr => {
                    this.$root.$emit('renderError', xhr)
                })
            }
        },
        addEmails() {
            this.form.emails.push(
                {'email': '', 'phone': ''},
            )
        },
        removeEmails(index) {
            const providerEmailId =this.form.emails[index].id
            if (providerEmailId) {
                this.deletedEmail.push(providerEmailId)
            }
            this.form.emails.splice(index, 1)
        }
    }
}
</script>

<style>
/* Rimuovi effetti hover nella modale */
.provider-dialog .v-btn:hover::before,
.provider-dialog .v-btn:focus::before {
  opacity: 0 !important;
}

.provider-dialog .v-input:hover .v-input__slot {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.provider-dialog .v-input--is-focused .v-input__slot {
  border-color: var(--v-primary-base) !important;
}

.provider-dialog .v-card:hover {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}
</style>
